import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { DeliveryIndicatorBasicContainer } from '../containers/DeliveryIndicatorBasic.js';
import { DeliveryIndicatorFullDateContainer } from '../containers/DeliveryIndicatorFullDate.js';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/svc-dynamic-delivery-estimation';
import 'classnames';
import '@grandvisionhq/icons';

var DeliveryIndicator = (_param)=>{
    var { items , deliveryResolver , availability , fallbackLabel , hasRxLens  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "items",
        "deliveryResolver",
        "availability",
        "fallbackLabel",
        "hasRxLens"
    ]);
    const { isDeliveryFullDateEnabled  } = useFeatureToggles();
    const { getLabel  } = useIntl();
    const fallbackLabelValue = fallbackLabel !== null && fallbackLabel !== void 0 ? fallbackLabel : getLabel('products.deliveryIndicator.fallbackMessage');
    // Full date delivery indicator that fetches a calculated delivery estimate from the backend
    if (isDeliveryFullDateEnabled && items && items.length > 0) {
        return /*#__PURE__*/ React.createElement(DeliveryIndicatorFullDateContainer, swcHelpers.extends({
            items: items,
            fallbackLabel: fallbackLabelValue,
            hasRxLens: hasRxLens
        }, rest));
    }
    return(// Basic delivery indicator that renders delivery estimate based on stock levels
    /*#__PURE__*/ React.createElement(DeliveryIndicatorBasicContainer, swcHelpers.extends({
        deliveryResolver: deliveryResolver,
        availability: availability,
        fallbackLabel: fallbackLabelValue
    }, rest)));
};

export { DeliveryIndicator };
//# sourceMappingURL=DeliveryIndicator.js.map
